import Cookies from 'js-cookie';

const cookieService = {
  get: Cookies.get,
  set: Cookies.set,
  remove: Cookies.remove,
};

export default cookieService;
